import { ReactNode } from "react"
import cn from "classnames"

import style from "ui-kit/components-branded/Modal/Content/style.module.scss"
import { Icon } from "components"

interface ModalContentProps {
    onCloseClick?: () => void
    heading?: ReactNode
    isFullHeightMobile?: boolean
    className?: string
    isBoxHaveNoShadow?: boolean
    isHalf?: boolean
    padding?: "S" | "M" | "L"
    width?: "S" | "M"
    children: ReactNode
    id?: string
}

export function Content({
    children,
    onCloseClick,
    heading,
    className,
    isFullHeightMobile,
    isBoxHaveNoShadow,
    padding = "L",
    isHalf,
    id,
    width,
    ...props
}: ModalContentProps) {
    return (
        <div
            {...props}
            id={id}
            className={cn(style.modalContainer, className, {
                [style.isHalf]: isHalf,
                [style.noBoxShadow]: isBoxHaveNoShadow,
                [style.paddingS]: padding === "S",
                [style.paddingM]: padding === "M",
                [style.paddingL]: padding === "L",
                [style.widthS]: width === "S",
                [style.widthM]: width === "M",
                [style.isFullHeightMobile]: isFullHeightMobile,
            })}
        >
            {onCloseClick && (
                <div className={style.close}>
                    <Icon type="menu-close-big" size={24} onClick={onCloseClick} />
                </div>
            )}
            {heading && <div className={style.heading}>{heading}</div>}
            {children}
        </div>
    )
}
